const index = [
    { 'name': "乙醛" },
    { 'name': "乙酸" },
    { 'name': "乙酸酐" },
    { 'name': "丙酮" },
    { 'name': "丙烯醛" },
    { 'name': "丙烯酸" },
    { 'name': "烯丙醇" },
    { 'name': "烯丙基氯" },
    { 'name': "氨" },
    { 'name': "戊醇" },
    { 'name': "苯胺" },
    { 'name': "苯甲醚" },
    { 'name': "胂" },
    { 'name': "苯" },
    { 'name': "苯甲醇" },
    { 'name': "甲酸苯酯" },
    { 'name': "溴" },
    { 'name': "溴苯" },
    { 'name': "丁二烯" },
    { 'name': "丁烷" },
    { 'name': "丁烯" },
    { 'name': "正丁醇" },
    { 'name': "叔丁醇" },
    { 'name': "丁硫醇" },
    { 'name': "正丁胺" },
    { 'name': "二硫化碳" },
    { 'name': "氯苯" },
    { 'name': "氯丁二烯" },
    { 'name': "邻氯甲苯" },
    { 'name': "巴豆醛" },
    { 'name': "异丙基苯" },
    { 'name': "乙烯" },
    { 'name': "乳酸乙荃" },
    { 'name': "乙酸乙酯" },
    { 'name': "丙烯酸乙酯" },
    { 'name': "乙醇" },
    { 'name': "乙苯" },
    { 'name': "乙硫醇" },
    { 'name': "硫化乙烷" },
    { 'name': "乙胺" },
    { 'name': "乙二醇" },
    { 'name': "环氧乙烷" },
    { 'name': "糖醛" },
    { 'name': "戊二醛" },
    { 'name': "正庚烷" },
    { 'name': "正己烷" },
    { 'name': "己醇" },
    { 'name': "硫化氢" },
    { 'name': "碘" },
    { 'name': "醋酸异戊酯" },
    { 'name': "异丁烷" },
    { 'name': "异丁醇" },
    { 'name': "异丁烯" },
    { 'name': "异辛烷" },
    { 'name': "异戊烷" },
    { 'name': "乙酸异丙酯" },
    { 'name': "异丙醇" },
    { 'name': "异丙醚" },
    { 'name': "乙酸甲酯" },
    { 'name': "溴代甲烷" },
    { 'name': "甲基醚" },
    { 'name': "甲基碘" },
    { 'name': "异氰酸甲酯" },
    { 'name': "甲硫醇" },
    { 'name': "水杨酸甲酯" },
    { 'name': "二甲硫醚" },
    { 'name': "甲基叔丁醚" },
    { 'name': "甲胺" },
    { 'name': "甲基环己烷" },
    { 'name': "芥子气" },
    { 'name': "萘" },
    { 'name': "一氧化氮" },
    { 'name': "硝基苯" },
    { 'name': "二氧化氮" },
    { 'name': "壬烷" },
    { 'name': "正辛烷" },
    { 'name': "戊烷" },
    { 'name': "四氯乙烯" },
    { 'name': "苯基醚" },
    { 'name': "磷化氢" },
    { 'name': "间戊二烯" },
    { 'name': "丙烯" },
    { 'name': "丙醛" },
    { 'name': "乙酸正丙酯" },
    { 'name': "丙二醇" },
    { 'name': "嘧啶" },
    { 'name': "苯乙烯" },
    { 'name': "塔崩" },
    { 'name': "四乙铅" },
    { 'name': "四氢呋喃" },
    { 'name': "甲苯" },
    { 'name': "邻甲苯胺" },
    { 'name': "三氯乙烯" },
    { 'name': "三乙胺" },
    { 'name': "三甲胺" },
    { 'name': "溴乙烯" },
    { 'name': "氯乙烯" },
    { 'name': "间二甲苯" },
    { 'name': "邻二甲苯" },
    { 'name': "对二甲苯" }
]
const srt_index = [
    { 'name': "可燃气" },
    { 'name': "乙酸" },
    { 'name': "丙酮" }, 
    { 'name': "乙酸丁酯" },
    { 'name': "环己烷" },
    { 'name': "乙醇" },
    { 'name': "乙酸乙酯" },
    { 'name': "乙烯" }, 
    { 'name': "氢" },
    { 'name': "异丁烷" },
    { 'name': "异丁醇" },
    { 'name': "异辛烷值" },
    { 'name': "异戊烷" },
    { 'name': "异丙醇" }, 
    { 'name': "甲醇" },
    { 'name': "甲基乙基酮" },
    { 'name': "丁烷" },
    { 'name': "庚烷" },
    { 'name': "己烷" },
    { 'name': "戊烷" },
    { 'name': "丙醇" }, 
    { 'name': "丙烷" },
    { 'name': "苯乙烯" },
    { 'name': "甲苯" },
    { 'name': "氨" },
    { 'name': "丙烯" }, 
    { 'name': "一氧化碳" },
    { 'name': "二甲苯" },
    { 'name': "辛烷" },
]
export default {
    index,
    srt_index
}


// WEBPACK FOOTER //
// ./src/pages/admincenter/toxic.js